module.exports = __webpack_public_path__ + "static/media/INTERACCION_COMUNICACION.d6bfc0bc.png";